var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SliderSelector',_vm._b({attrs:{"mandatory":_vm.isMandatory,"value":_vm.value},on:{"input":_vm.onInput}},'SliderSelector',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }